import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["hostPricing", "scopesLookup", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { addFlag as _addFlag, removeFlag as _removeFlag } from '../../../actions/Flags';
import { doInitiateInstallModeForIdentifier } from '../../../actions/Installation/InstallMode/DeterminingInstallMode';
import { makeEmceeFlag } from '../../../records/Flag';
import formatInstalledAppsToMap from '../../../utils/formatInstalledAppsToMap';
import { EmceeAppInstallCache } from '../../AppInstallDialog';
import DiscoverAppDetails from '../components/DiscoverAppDetails';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = (state, ownProps) => {
  const installedAppsMap = formatInstalledAppsToMap(state.installedApps.locallyInstalledApps, state.installedApps.globallyInstalledApps);
  const {
    appKey
  } = ownProps;
  return {
    installedApp: appKey && installedAppsMap.has(appKey) ? installedAppsMap.get(appKey) : undefined,
    hostPricing: state.hostPricing.hostPricing,
    scopesLookup: state.scopes.scopesLookup
  };
};
const mapDispatchToProps = (dispatch, ownProps) => ({
  openInstallDialog: _ref => {
    let {
      installableAppId,
      relayState,
      context
    } = _ref;
    return dispatch(doInitiateInstallModeForIdentifier({
      mpacBaseUrl: ownProps.mpacBaseUrl,
      installableAppId,
      relayState,
      context
    }));
  },
  addFlag: flag => {
    dispatch(_addFlag({
      flag: makeEmceeFlag(flag)
    }));
  },
  removeFlag: key => dispatch(_removeFlag(key))
});
function AppInstallCacheProvider(_ref2) {
  let {
      hostPricing,
      scopesLookup,
      children
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded);
  const [appInstallCache, setAppInstallCache] = useState({
    pending: true,
    error: null,
    result: null
  });
  useEffect(() => {
    if (hostPricing.pending || scopesLookup.isEmpty()) {
      return;
    }
    const cacheContent = {
      pending: false,
      result: null,
      error: null
    };
    if (hostPricing.error || scopesLookup.value.isLeft()) {
      cacheContent.error = _objectSpread(_objectSpread({}, hostPricing.error && {
        hostLicense: hostPricing.error
      }), scopesLookup.value.isLeft() && {
        scopesLookup
      });
    } else {
      cacheContent.result = {
        hostLicense: hostPricing.result,
        scopesLookup
      };
    }
    setAppInstallCache(cacheContent);
  }, [hostPricing, scopesLookup]);
  return /*#__PURE__*/_jsx(EmceeAppInstallCache.Provider, {
    value: appInstallCache,
    children: /*#__PURE__*/_jsx(DiscoverAppDetails, _objectSpread({
      hostPricing: hostPricing
    }, props))
  });
}
export default connect(mapStateToProps, mapDispatchToProps)(AppInstallCacheProvider);